import React, { useEffect } from 'react';

import { Form, Row, Col, Button, Modal, Spin, message } from 'antd';
import { HJCreateReceiver } from '@FORMS';
import { updateReceiver } from '@RECEIVERS';
import { AiFillSave } from 'react-icons/ai';

const UpdateReceiverModal = ({
  form,
  onClose,
  setStep,
  setSpin,
  spin,
  updateValues,
}) => {
  useEffect(() => {
    let obj = {
      firstName: updateValues.firstName,
      lastName: updateValues.lastName,
      phone: updateValues.phone,
      recipientCity: updateValues.address.city.name,
      recipientTown: updateValues.address.town.name,
      recipientDistrict: updateValues.address?.district?.name,
      recipientAddressLine: updateValues.address.addressLine,
    };
    form.setFieldsValue(obj);
  }, [form, updateValues]);
  const handleUpdate = async (values) => {
    setSpin(true);
    let obj = {
      firstName: values.firstName,
      lastName: values.lastName,
      phone: values.phone.replace(/ /g, ''),
      address: {
        city: values.recipientCity,
        town: values.recipientTown,
        district: values.recipientDistrict,
        addressLine: values.recipientAddressLine,
      },
    };
    const response = await updateReceiver(obj, updateValues._id);
    setSpin(false);
    if (response.id) {
      message.success({
        content: 'Kişi başarıyla güncellendi',
        className: 'app-success-message',
      });
      form.resetFields();
      setStep('TABLE');
    } else {
      message.error({
        content: response?.response?.data?.error?.msg,
        className: 'app-error-message',
      });
    }
  };

  return (
    <Modal
      visible
      title="Kişiyi Düzenle"
      onCancel={onClose}
      width={1350}
      footer={false}
    >
      <Form form={form} layout="vertical">
        <HJCreateReceiver form={form} />

        <Row gutter={24}>
          <Col flex={'auto'}>
            <Spin spinning={spin} />
          </Col>
          <Col flex="auto">
            <Button
              style={{ float: 'right' }}
              type="danger"
              onClick={() => {
                setStep('TABLE');
                form.resetFields();
              }}
              icon={<AiFillSave />}
            >
              Vazgeç
            </Button>
          </Col>
          <Col flex="none">
            <Button
              style={{ float: 'right' }}
              type="primary"
              onClick={() => {
                form.validateFields().then((values) => {
                  handleUpdate(values);
                });
              }}
              icon={<AiFillSave />}
            >
              Kişiyi Kaydet
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default UpdateReceiverModal;
